const _excluded = ["failureToastProps", "onSuccess", "onSubmit", "dismissModal"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useGlobalContext } from 'seagull';
import React, { useState } from 'react';
import { ConfirmationModal } from 'seagull';
import { handlePromise } from "../../infra/utils";
export default function VendorAccountantAccessModal(props) {
  const {
      failureToastProps,
      onSuccess,
      onSubmit,
      dismissModal
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const globalContext = useGlobalContext();
  const [loading, setLoading] = useState(false);
  async function onPrimaryButtonClick() {
    setLoading(true);
    const {
      success
    } = await handlePromise(onSubmit());
    if (success) {
      await onSuccess();
    } else if (failureToastProps) {
      globalContext.showErrorToast(failureToastProps.text, failureToastProps.testid);
    }
    setLoading(false);
    dismissModal();
  }
  return /*#__PURE__*/React.createElement(ConfirmationModal, _extends({
    textAlignCenter: false,
    secondaryButtonLabel: "Cancel",
    onCloseButtonClick: dismissModal,
    onSecondaryButtonClick: dismissModal,
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonLoading: loading
  }, rest));
}